// ═══════════════════════════════════════════════════════════════
// DocCategoryChip.js — Pastille catégorie document (Family P2)
// ═══════════════════════════════════════════════════════════════
// Chip compacte (icône Lucide + label, optionnellement tag nationalité).
// Utilisée sur FilesSidebar / FilePreviewModal pour afficher à quelle
// catégorie family (migration 067) un document a été routé.
//
// Props :
//   category     : { code, label, icon, color }  — row family_doc_category
//   nationalityTag : string | null               — ex "FR", "SN", "FR-SN"
//   size         : 'sm' | 'md' (défaut sm)
//   onClick      : optionnel
// ═══════════════════════════════════════════════════════════════

import React from 'react';
import * as Icons from 'lucide-react';

const FALLBACK_COLOR = '#6366f1';
const FALLBACK_ICON = 'Tag';

const DocCategoryChip = ({ category, nationalityTag = null, size = 'sm', onClick = null }) => {
    if (!category) return null;

    const IconComp = Icons[category.icon] || Icons[FALLBACK_ICON];
    const color = category.color || FALLBACK_COLOR;

    const sizes = {
        sm: { padding: '3px 8px', fontSize: 11, iconSize: 12, gap: 5, radius: 10 },
        md: { padding: '5px 10px', fontSize: 13, iconSize: 14, gap: 6, radius: 12 },
    };
    const s = sizes[size] || sizes.sm;

    // Fond translucide de la couleur, bordure discrète, texte couleur
    const style = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: s.gap,
        padding: s.padding,
        fontSize: s.fontSize,
        fontWeight: 500,
        color,
        background: `${color}18`,       // 18 ≈ alpha 0.09
        border: `1px solid ${color}33`,
        borderRadius: s.radius,
        cursor: onClick ? 'pointer' : 'default',
        userSelect: 'none',
        whiteSpace: 'nowrap',
        transition: 'background 0.15s',
    };

    return (
        <span
            style={style}
            onClick={onClick}
            onMouseEnter={(e) => { if (onClick) e.currentTarget.style.background = `${color}28`; }}
            onMouseLeave={(e) => { if (onClick) e.currentTarget.style.background = `${color}18`; }}
            title={nationalityTag ? `${category.label} · ${nationalityTag}` : category.label}
        >
            {IconComp && <IconComp size={s.iconSize} strokeWidth={2} />}
            <span>{category.label}</span>
            {nationalityTag && (
                <span style={{ opacity: 0.7, fontSize: s.fontSize - 1 }}>· {nationalityTag}</span>
            )}
        </span>
    );
};

export default DocCategoryChip;
